import APIClient from '@/shared/http/clients/api'

const resourceName = 'VistoriaChecklistSupervisaoInconformidade'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByVistoria = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/byvistoria/${id}`, data, config)

const checklistsurveyunconfirmedRepository = {
  GetByVistoria
}
export default checklistsurveyunconfirmedRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/checklistsurveychecklistsurveyunconfirmed.js